import { render, staticRenderFns } from "./TimeslotSelector.vue?vue&type=template&id=517b5f6e&"
import script from "./TimeslotSelector.vue?vue&type=script&lang=ts&"
export * from "./TimeslotSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports